import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc = (compact: boolean) => ({
  minWidth: (p) => `${compact ? p.spacing(4) : p.spacing(13.5)} !important`,
});
